import { render, staticRenderFns } from "./SidePanelTab.vue?vue&type=template&id=10635467&scoped=true&"
import script from "./SidePanelTab.vue?vue&type=script&lang=js&"
export * from "./SidePanelTab.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelTab.vue?vue&type=style&index=0&id=10635467&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10635467",
  null
  
)

export default component.exports